var _circle, _circle2, _circle3, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function Svg1F603(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    fill: "#FFDD67",
    cx: 32,
    cy: 32,
    r: 30
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    fill: "#664E27",
    cx: 20.5,
    cy: 24.5,
    r: 5
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    fill: "#664E27",
    cx: 43.5,
    cy: 24.5,
    r: 5
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#664E27",
    d: "M49.001 38.05c0-.803-.475-1.808-1.822-2.066-3.465-.662-8.582-1.343-15.18-1.343-6.595 0-11.714.681-15.177 1.343-1.35.258-1.822 1.263-1.822 2.066 0 7.271 5.611 14.591 17 14.591 11.388 0 17.001-7.32 17.001-14.591z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M44.69 38.283c-2.195-.368-6.838-1.013-12.69-1.013-5.853 0-10.496.645-12.691 1.013-1.294.218-1.373.743-1.283 1.486.054.442.137.975.265 1.553.142.64.262.936 1.266.816 1.92-.229 22.967-.229 24.888 0 1.004.119 1.123-.177 1.266-.816.127-.578.211-1.11.264-1.553.088-.743.01-1.268-1.285-1.486z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg1F603);
export default __webpack_public_path__ + "static/media/1f603.bdfd7e9058f1c35c2a673a78d2fd4287.svg";
export { ForwardRef as ReactComponent };